import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

type RefundStatus = "REFUNDED" | "TO_REFUND";

const statusProps: Record<
  RefundStatus,
  { backgroundColor: string; textColor: string }
> = {
  REFUNDED: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  TO_REFUND: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
  },
};

interface TableTagRefundStatusProps {
  status: string;
}

export const TableTagRefundStatus = (props: TableTagRefundStatusProps) => {
  const { t } = useTranslation();
  const statusProp = statusProps[props.status as RefundStatus];
  if (!statusProp) {
    return null;
  }

  return (
    <Tag
      text={t(`electric_charging.refundStatus.${props.status}`)}
      backgroundColor={statusProp.backgroundColor}
      textColor={statusProp.textColor}
    />
  );
};
